// ========================================
// DATA DEFINITIONS
// ========================================

// Projects data
const projects = [
	{
		title: "雲端貓居 NyankoHost",
		timeframe: "Current",
		description: "A multi-tenant Discord bot and web hosting platform focused on high reliability and UX/DX.",
		image: "assets/img/projects/nyankohost.png",
		link: "https://nyanko.host",
		linkText: "Learn More →"
	},
	{
		title: "DCTW Unofficial API",
		timeframe: "Current",
		description: "An unofficial (partnered) API for the <a href='https://dctw.xyz' target='_blank' rel='noopener'>dctw.xyz</a> platform. Provides endpoints for fetching listing data and more.",
		image: "assets/img/projects/dctw.png",
		mode: "contain",
		link: "https://dctw.nkhost.dev/redoc",
		linkText: "API Documentations →"
	},
	{
		title: "錢叡",
		timeframe: "2023",
		description: "A simple yet powerful balance tracking bot for Discord shops. Trusted by 1000+ servers to manage their virtual economies.",
		image: "assets/img/projects/moneyray.png",
		mode: "contain",
		link: "https://discord.com/api/oauth2/authorize?client_id=1016161917829652530&permissions=67584&scope=bot",
		linkText: "Invite Bot →"
	},
	{
		title: "Other Projects",
		description: "For a more comprehensive list of my projects, please feel free to reach out to me directly!",
		image: "assets/img/projects/placeholder.jpg",
		mode: "contain",
		link: "#related",
		linkText: "Contact Me →"
	}
]

// Skills data
const skills = [
	{ icon: "fa-brands fa-python", text: "Python Development" },
	{ icon: "fa-solid fa-server", text: "DevOps & Infrastructure" },
	{ icon: "fa-brands fa-git-alt", text: "Version Control (Git)" },
	{ icon: "fa-brands fa-docker", text: "Containerization (Docker)" },
	{ icon: "fa-solid fa-comments", text: "Communication & Collaboration" }
];

// Work experience data
const workExperience = [
	{
		time: "08/2025 — Present",
		title: "Founder",
		location: "SleepyNeko Studios Ltd.",
		locationExtra: "(雲端貓居 NyankoHost)",
		description: "Building and running a free Discord bot hosting platform for individual developers and small businesses."
	},
	{
		time: "03/2025 — 04/2026",
		title: "Deskside Support Engineer",
		location: "Primetech Technology Ltd.",
		description: "Providing on-site technical support and troubleshooting for enterprise client."
	},
	{
		time: "06/2022 — 10/2024",
		title: "Freelance Python Developer",
		location: "Self-Employed",
		description: "Created 200+ custom Python solutions including automation tools, Discord bots, and other applications."
	},
	{
		time: "05/2022 — 10/2024",
		title: "Co-Founder",
		location: "Kawaverse Network Ltd.",
		locationExtra: "(dissolved 2024)",
		description: "Co-founded a vtuber agency and managed all technical infrastructure."
	},
	{
		time: "04/2021 — 02/2026",
		title: "Public Relations Manager",
		location: "Hyper Group Network Ltd.",
		description: "Managing partnerships and collaboration opportunities with external organizations."
	}
];

// Education data
const education = [
	{
		time: "08/2023 — 01/2025",
		institution: "Pasadena City College",
		details: ["Computer Science"]
	},
	{
		time: "10/2021 — 05/2023",
		institution: "Mark Keppel High School",
		details: ["High School Diploma", "AP CSA: 5"]
	},
	{
		time: "09/2017 — 08/2021",
		institution: "Christian & Missionary Alliance Sun Kei Secondary School",
		details: ["F.1-4"]
	}
];

// Certifications data
const certifications = [
	{
		icon: "fa-solid fa-award",
		title: "CompTIA A+",
		issuer: "CompTIA",
		date: "January 2025",
		link: "https://cp.certmetrics.com/CompTIA/en/public/verify/credential/HTN48CEQRJE11DW2"
	},
	{
		icon: "fa-solid fa-award",
		title: "Fortinet Certified Associate in Cybersecurity",
		issuer: "Fortinet",
		date: "December 2024",
		link: "https://training.fortinet.com/pluginfile.php/1/tool_certificate/issues/1765277048/5538737508HT.pdf"
	},
	{
		icon: "fa-brands fa-github",
		title: "GitHub Foundations",
		issuer: "GitHub",
		date: "December 2024",
		link: "https://www.credly.com/badges/47bd4b32-6587-479a-9ccb-5785f350ac7d"
	},
	{
		icon: "fa-brands fa-google",
		title: "Google IT Support Specialization",
		issuer: "Google",
		date: "September 2024",
		link: "https://www.coursera.org/account/accomplishments/professional-cert/23CUN65I3IRQ"
	},
	{
		icon: "fa-brands fa-microsoft",
		title: "Microsoft Office Specialist: Word Associate (Office 2019)",
		issuer: "Microsoft",
		date: "November 2020",
		link: "/assets/docs/mos2019word.pdf"
	}
];

// Friends data
const friends = [
	{
		name: "洋蔥",
		username: "onion.tw",
		avatar: "6d777787ddc97b46e6d8c0723c2fcaac",
		link: "https://2manylinks.me/onionken"
	},
	{
		name: "watermelon",
		username: "watermelon1024",
		avatar: "773ca5310680bcfbcd663708cbee27a9",
		link: "https://github.com/watermelon1024/"
	},
	{
		name: "貓貓",
		username: "command_cat",
		avatar: "df33b754e636157289ddf25d5d770c50",
		link: "https://littlecommandcat.pages.dev/"
	},
	{
		name: "二氧化碳",
		username: "co2_tw",
		avatar: "e40a23fd8ee10084b50168b6e3966c81",
		link: "https://antiraidx.com/"
	},
	{
		name: "CO",
		username: "smallzerol",
		avatar: "299fab73e7a4931aa1cbbc6590c29157",
		link: "https://smallzero.net/"
	},
	{
		name: "CreeperDEV",
		username: "creeperdev.me",
		avatar: "2652ed119e90a6bb1c5094b92622340f",
		link: "https://creeperdev.me/"
	},
	{
		name: "2023",
		username: "2023_myself",
		avatar: "95147e62a19ac01ddcd8f1a146b6b2f1",
		link: "https://onioncosplay.xyz/"
	},
	{
		name: "Nicko",
		username: "nicko9487",
		avatar: "d5dc6b8841e28e8b2759fd633fc4abf8",
		link: "https://avianjay.sbs"
	},
	{
		name: "dingnaam",
		username: "dingnaam",
		avatar: "efc708c8524ac4ec9ada4b18e4ef3de5",
		link: "https://dingnaam.nkhost.dev"
	}
];

// ========================================
// TYPING ANIMATION
// ========================================

function initializeTyping() {
	new TypeIt("#typing-0", {
		speed: 60,
		deleteSpeed: 15,
		startDelay: 2800,
		lifeLike: true,
		waitUntilVisible: true,
		afterComplete: async (instance) => {
			instance.destroy();

			const toType = [
				"a <strong>Software Engineer</strong>",
				"a <strong>Discord Bot Developer</strong>",
				"a <strong>System & Network Engineer</strong>",
				"a <strong>Computer Science Student</strong>",
				"an <strong>Entrepreneur</strong>",
			]

			const newInstance = new TypeIt("#typing-1", {
				speed: 80,
				deleteSpeed: 15,
				lifeLike: true,
				nextStringDelay: 0,
				waitUntilVisible: true,
				loop: true,
				loopDelay: 0,
			})

			toType.forEach((phrase, index) => {
				newInstance
				.type(phrase)
				.pause(3000)
				.delete()
				.pause(250);
			});
			newInstance.go();
		},
	})
	.type("<strong>Nice to meet you~ /ᐠ˵- ⩊ -˵マ</strong>")
	.pause(2000)
	.delete()
	.pause(300)
	.options({ speed: 70 })
	.type("I am <strong>Ryan</strong> ฅ^>ヮ<^₎")
	.pause(250)
	.type("\n")
	.pause(500)
	.go();
}

// ========================================
// SECTION GENERATORS
// ========================================

// Generate projects list
function generateProjectsList() {
	const container = document.getElementById('projects-list');
	if (!container) return;

	projects.forEach(project => {
		const article = document.createElement('article');
		article.className = 'col-4 col-6-small col-12-xsmall work-item';

		const imgLink = project.link && !project.link.startsWith("#") ? project.link : '#';
		const target_rel = imgLink !== '#' ? 'target="_blank" rel="noopener"' : '';

		article.innerHTML = `
			<a href="${imgLink}" class="image fit thumb" ${target_rel || 'onclick="return false;"'}>
				<img src="${project.image}" alt="${project.title} thumbnail" loading="lazy" ${project.mode ? `style="object-fit: ${project.mode};"` : ''}/>
			</a>
			<h3>${project.title} <span class="sm">${project.timeframe ? `(${project.timeframe})` : ''}</span></h3>
			<p>${project.description}</p>
			<a class="button small" href="${project.link}" ${target_rel}>${project.linkText}</a>
		`;
		container.appendChild(article);
	});
}

// Generate skills list
function generateSkillsList() {
	const container = document.getElementById('skills-list');
	if (!container) return;

	skills.forEach(skill => {
		const li = document.createElement('li');
		li.innerHTML = `<i class="icon ${skill.icon}"></i>${skill.text}`;
		container.appendChild(li);
	});
}

// Generate work experience
function generateWorkExperience() {
	const container = document.getElementById('experience-timeline');
	if (!container) return;

	workExperience.forEach(job => {
		const article = document.createElement('article');
		article.className = 'event';
		
		const locationHtml = job.locationExtra 
			? `${job.location}&nbsp;<span class="sm">${job.locationExtra}</span>`
			: job.location;
		
		article.innerHTML = `
			<span class="time">${job.time}</span>
			<h3>${job.title}</h3>
			<span class="location">${locationHtml}</span>
			<p>${job.description}</p>
		`;
		
		container.appendChild(article);
	});
}

// Generate education
function generateEducation() {
	const container = document.getElementById('education-timeline');
	if (!container) return;

	education.forEach(edu => {
		const article = document.createElement('article');
		article.className = 'event education-event';
		
		let detailsHtml = '';
		if (edu.details && edu.details.length > 0) {
			const detailsText = edu.details.join('<div class="dot"></div>');
			detailsHtml = `<span class="sm"><div class="dot"></div>${detailsText}</span>`;
		}
		
		article.innerHTML = `
			<span class="time">${edu.time}</span>
			<h3>${edu.institution}${detailsHtml}</h3>
		`;
		
		container.appendChild(article);
	});
}

// Generate certifications
function generateCertifications() {
	const container = document.getElementById('certifications-list');
	if (!container) return;

	certifications.forEach(cert => {
		const li = document.createElement('li');
		
		li.innerHTML = `
			<a href="${cert.link}" target="_blank" rel="noopener">
				<i class="icon ${cert.icon}"></i>
				<div class="cert-info">
					<h3>${cert.title}</h3>
					<span class="cert-meta">${cert.issuer}<div class="dot"></div>${cert.date}</span>
				</div>
				<i class="icon fa-solid fa-arrow-right cert-arrow"></i>
			</a>
		`;
		
		container.appendChild(li);
	});
}

// Generate friends list
function generateFriendsList() {
	const container = document.getElementById('friends-list');
	if (!container) return;
	
	const defaultAvatar = 'https://www.gravatar.com/avatar/0?d=mp&size=80';
	const defaultLink = 'https://example.com';

	friends.forEach(friend => {
		const div = document.createElement('div');
		div.className = 'col-3 col-6-small col-12-xsmall';
		
		let avatarUrl = defaultAvatar;
		if (friend.avatar && friend.avatar.trim() !== '') {
			const trimmedAvatar = friend.avatar.trim();
			if (trimmedAvatar.startsWith('/') || trimmedAvatar.startsWith('https://')) {
				avatarUrl = trimmedAvatar;
			} else {
				avatarUrl = `https://www.gravatar.com/avatar/${trimmedAvatar}?d=mp&size=80`;
			}
		}
		
		const linkUrl = friend.link && friend.link.trim() !== '' ? friend.link.trim() : defaultLink;
		
		div.innerHTML = `
			<a href="${linkUrl}" target="_blank" rel="noopener">
				<img src="${avatarUrl}" alt="${friend.username}" loading="lazy" />
				<span class="friend-text">
					<span class="name">${friend.name}</span>
					<span class="subtext">@${friend.username}</span>
				</span>
			</a>
		`;
		
		container.appendChild(div);
	});
}

// Initialize back-to-top button
function initializeBackToTop() {
	const button = document.getElementById('back-to-top');
	if (!button) return;

	const toggleVisibility = () => {
		if (window.scrollY > 400) {
			button.classList.add('is-visible');
		} else {
			button.classList.remove('is-visible');
		}
	};

	window.addEventListener('scroll', toggleVisibility, { passive: true });

	button.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	toggleVisibility();
}

// ========================================
// INITIALIZATION
// ========================================

// Initialize all sections when DOM is ready
function initializeSections() {
	initializeTyping();
	generateProjectsList();
	generateSkillsList();
	generateWorkExperience();
	generateEducation();
	generateCertifications();
	generateFriendsList();
	initializeBackToTop();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeSections);
} else {
	initializeSections();
}
